import { useSyncExternalStore } from "react";

/* Whether the visitor asked for less movement.
 *
 * useSyncExternalStore rather than useState + useEffect: a media query IS an external store, and
 * this is the one hook that takes a separate server snapshot. The server cannot know the
 * preference, so it reports false — the only value matching what SSR emitted — and the client
 * reads the real query on its first commit without a second render pass.
 *
 * CSS-driven motion does not need this hook at all: global-css.js clamps animations and transitions
 * globally under prefers-reduced-motion. Use this only to gate something JS STARTS, such as video
 * playback or a carousel interval.
 */
const QUERY = "(prefers-reduced-motion: reduce)";

const subscribe = (onChange) => {
  if (typeof window === "undefined" || !window.matchMedia) return () => {};

  const query = window.matchMedia(QUERY);
  query.addEventListener("change", onChange);
  return () => query.removeEventListener("change", onChange);
};

const getSnapshot = () => window.matchMedia(QUERY).matches;

const getServerSnapshot = () => false;

const useReducedMotion = () =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

export default useReducedMotion;
